import styled, { css } from 'styled-components';
import Cleave from 'cleave.js/react';
import { Blue, Gray, Red } from '../../colors';
const inputStyles = css `
  width: 100%;
  display: block;
  border: 1px solid ${Gray.dark};
  border-radius: 3px;
  color: ${Blue.dark};
  font-family: Gilroy;
  font-size: 1rem;
  line-height: 1.25rem;
  font-weight: bold;
  padding: 0.5rem;
  appearance: none;
  box-sizing: border-box;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${Gray.dark};
  }

  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type=number] {
    -moz-appearance: textfield;
  }
`;
const labelStyles = css `
  display: inline-block;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 1.25rem;
`;
export const InputGroup = styled.div `
  display: block;
  width: ${({ width }) => !width ? '100%' : width};

`;
export const InputWrapper = styled.div `
  display: flex;
  position: relative;
`;
export const Label = styled.label `
  ${labelStyles};
  color: ${Blue.dark};
  padding-bottom: 4px;
`;
export const ErrorLabel = styled.span `
  ${labelStyles};
  font-weight: 500;
  line-height: 0.875rem;
  padding-top: 4px;
  color: ${Red.normal};
`;
export const CleaveInput = styled(Cleave) `
  ${inputStyles};
`;
export const CleaveCardNumberInput = styled(CleaveInput) `
  padding: 0.5rem 3rem 0.5rem 0.5rem;
`;
export const StyledNameInput = styled.input `
  ${inputStyles};
  text-transform: uppercase;
`;
export const CreditCardIcon = styled.img `
  position: absolute;
  top: 0.438rem;
  right: 0.5rem;
  width: 2.25rem;
  height: 1.5rem;
`;
//# sourceMappingURL=styles.js.map